import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core';
import { BackdropCircular } from 'components';
import { getRPAChargeCodesUnmappedApi } from 'api';
import useStyles from '../styles';
import UnmappedDataTableHeadRow from './UnmappedDataTableHeadRow';
import UnmappedDataTableRow from './UnmappedDataTableRow';


const Unmapped = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [sort, setSort] = useState({fieldName: 'charge_code_created_at_sort', sortDirection: 'asc'});
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  const {
    chargeCodesUnmapped,
    chargeCodesUnmappedTotalCount,
    isChargeCodesUnmappedLoading
  } = useSelector((state: IReduxState) => state.rpa);

  useEffect(() => {
    getRPAChargeCodesUnmappedApi({
      dispatch,
      sort,
      currentPage,
      rowsPerPage
    });
  }, [sort, currentPage, rowsPerPage]);

  const handleRequestSort = (_, property) => {
    const {fieldName, sortDirection} = sort;
    const isDesc = fieldName === property && sortDirection === 'desc';
    setSort(() => ({fieldName: property, sortDirection: isDesc ? 'asc' : 'desc'}));
  };

  const handleChangePage = (_, newPage) => {
    setCurrentPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  return (
    <div className="max-w-1000">
      <TableContainer className={classes.table}>
        <Table className={classes.table}>
          <TableHead>
            <UnmappedDataTableHeadRow
              sort={sort}
              handleRequestSort={handleRequestSort}
            />
          </TableHead>
          <TableBody>
            {chargeCodesUnmapped.length ?
              chargeCodesUnmapped.map((chargeCode) => (
                <UnmappedDataTableRow
                  key={chargeCode.id}
                  chargeCode={chargeCode}
                  sort={sort}
                  currentPage={currentPage}
                  rowsPerPage={rowsPerPage}
                />
              ))
              :
              <TableRow>
                <TableCell colSpan={12}>
                  <p className="text-center text-muted">No mapping data.</p>
                </TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
      {!!chargeCodesUnmappedTotalCount &&
        <TablePagination
          rowsPerPageOptions={[10, 20, 40, 80, 100]}
          component="div"
          className={classes.paginationContainer}
          count={chargeCodesUnmappedTotalCount}
          rowsPerPage={rowsPerPage}
          page={currentPage - 1}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      }
      <BackdropCircular loading={isChargeCodesUnmappedLoading} />
    </div>
  );
};

export default Unmapped;
